import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BookingFeeFormComponent } from './components/form/booking-fee-form.component'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { BookingFeesComponent } from './components/booking-fees/booking-fees.component'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { BookingFeesDialogService } from './components/booking-fees-dialog/booking-fees-dialog.service'
import { BookingFeesDialogComponent } from './components/booking-fees-dialog/booking-fees-dialog.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDatepickerModule,
    Tv3PlatformModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
  ],
  providers: [BookingFeesDialogService],
  declarations: [BookingFeeFormComponent, BookingFeesComponent, BookingFeesDialogComponent],
  exports: [BookingFeeFormComponent, BookingFeesComponent, BookingFeesDialogComponent],
})
export class BookingFeesModule {}
